import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSoundOn = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "var(--main-color)",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsxs("g", {
			fillRule: "nonzero",
			children: [
				/* @__PURE__ */ _jsx("path", { d: "M18.28 8.37a1.003 1.003 0 00-1.56 1.26 4 4 0 010 4.74A1 1 0 0017.5 16a1 1 0 00.78-.37 6 6 0 000-7.26z" }),
				/* @__PURE__ */ _jsx("path", { d: "M19.64 5.23a1.001 1.001 0 10-1.28 1.54A6.8 6.8 0 0121 12a6.8 6.8 0 01-2.64 5.23 1 1 0 101.28 1.54A8.75 8.75 0 0023 12a8.75 8.75 0 00-3.36-6.77z" }),
				/* @__PURE__ */ _jsx("path", { d: "M15 3.12a1 1 0 00-1 0L7.52 7.57h-5a1 1 0 00-1 1v6.86a1 1 0 001 1h5l6.41 4.4c.17.11.368.169.57.17a1 1 0 001-1V4a1 1 0 00-.5-.88zm-1.47 15L8.4 14.6a1 1 0 00-.57-.17H3.5V9.57h4.33a1 1 0 00.57-.17l5.1-3.5.03 12.22z" })
			]
		})
	})
});
export { SvgSoundOn as ReactComponent };
